import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RequestingParams } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const countReceivedFeedback = createAsyncThunk(
  "receivedFeedback/count",
  async (requestParams: RequestingParams, storeActions) => {
    const url = `api/v1/user/feedbacks/received/count` + requestParams.requestParams;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const countReceivedSlice = createSlice({
  name: "countReceived",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: -1 as Number | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(countReceivedFeedback.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(countReceivedFeedback.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(countReceivedFeedback.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = countReceivedSlice.actions;

export default countReceivedSlice;
